<div>
    <div [ngClass]="loggedUserRole == 4 ? 'col-md-12': 'admin'" style="display: flex; justify-content: flex-end;"
        appCanAccess [accessPolicy]="[9]">
        <div (click)="posActionosClick()" style="display: flex; justify-content: center; align-items: center; color: white; height: 42px; width: 182px; background-color: #2D5697; 
            border-radius: 5px; text-align: center; cursor: pointer;   font-weight: 400; font-size: 14px !important;">
            Sync POS
        </div>
    </div>
    <div class="col-md-12 filter-btn" appShowHide style="display: contents;">
        <button type="button" class="btn-filter" data-toggle="collapse" data-target="#filterCollapse"
            aria-expanded="false" aria-controls="collapseExample" (click)="refreshFilters()">
            <img src="../../../../../assets/icons/filter.png" id="navitem" width="16px" height="16px" alt=""
                loading="lazy" style="margin: 0px 5px ;">
            Filters
        </button>
    </div>
    <div class="collapse" id="filterCollapse">
        <div class="filterCol">
            <form [formGroup]="filterForm" id="filterForm">
                <div [ngClass]="loggedUserRole == 1 || loggedUserRole == 2 ? 'filtersBox' : 'filtersBoxAdmin' ">
                    <label class="filterLbl" for="menuName">Admin Filters</label>
                    <div class="row filtersRow">
                        <div [ngClass]="loggedUserRole == 1 || loggedUserRole == 2 ? 'superAdmin' : 'admin' ">
                            <label class="lblInput" for="menuName">Franchise</label>
                            <div class="filterInput">
                                <select class='form-control bulkInput selectpicker' id="spicker_franchise_oa"
                                    (ngModelChange)="selectFranchise($event)" formControlName="franchise"
                                    data-style="dropdownCustomStyle">
                                    <option selected value='' disabled
                                        data-content="<span class='text-secondary'>Nothing Selected</span>"></option>
                                    <option *ngFor="let franchise of franchises" [ngValue]="franchise.id">
                                        {{franchise.name}} </option>
                                </select>
                            </div>
                        </div>
                        <div>
                            <label class="lblInput" for="menuName">Outlet</label>
                            <div class="filterInput2">
                                <select class='form-control bulkInput selectpicker' id="spicker_shop_oa"
                                    formControlName="shop" (ngModelChange)="selectShop($event)"
                                    data-style="dropdownCustomStyle" disabled>
                                    <option selected value='' disabled
                                        data-content="<span class='text-secondary'>Nothing Selected</span>"></option>
                                    <option *ngFor="let shop of shops" [ngValue]="shop">
                                        {{shop.name}} </option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>


    <div class="container-responsive" [ngClass]="!isFilterClicked ? 'filterNotClicked' : 'filterClicked'">
        <div *ngIf='!orderActionFilterSelected' class="item" style="margin-top: 10px; font-size: 14px;">

            <p *ngIf='loggedUserRole == 3' class="alert alert-warning">Select outlet to load the order action data</p>

            <p *ngIf='loggedUserRole == 1 || loggedUserRole == 2' class="alert alert-warning">Select Franchise and
                Outlet to load the order action data</p>
        </div>

        <div *ngIf="orderActionFilterSelected">
            <div *ngIf="!orderActionLoader" class="item">
                <ngx-skeleton-loader class="skelton-tiles" count="1" [theme]="{ 
                'border-radius': '0px', 
                height: '100px','margin-top':'20px'
              }"></ngx-skeleton-loader>
            </div>
            <div *ngIf="orderActionLoader">
                <ng-container *ngIf="oderActionDetails.length > 0; else elseBlock">
                    <div slot="margin:15px 0px" *ngFor="let int of oderActionDetails">

                        <div class="col-md-12 franchiseShopCol">
                            <div class="subHeadingOrder">
                                {{int.franchise}} - {{int.shop}}
                            </div>

                        </div>

                        <app-table [isDataLoaded]="orderActionLoader" [tableData]="int.shopActions"
                            [tableInfo]="tableInfo" [filterSearchAvailability]="filterSearchAvailability"
                            (onChangeAccepting)="onChangeAccepting($event)"
                            (onOwnDriverChange)="onOwnDriverChange($event)"
                            (onChangeAutoAccepting)="onChangeAutoAccepting($event)" [tableConfig]="tableConfig"
                            [tableAction]="tableAction" [filterClickHeight]="filterClickHeight"
                            [filterNotClickHeight]="filterNotClickHeight" [filterAvailability]="filterAvailability"
                            [isFilterClicked]="isFilterClicked" [toggleAccess]="toggleAccess"
                            (placeTestOrders)="openPlaceTestOrder($event)"
                            (onPrepTimeSelect)="onPrepTimeSelect($event)"></app-table>

                    </div>
                </ng-container>
                <!-- No tableData -->
                <ng-template #elseBlock>
                    <p class="alert alert-info" style="font-size: 14px;">
                        No integrations available for this outlet!
                    </p>
                </ng-template>
            </div>
        </div>

    </div>
</div>
<!-- Sync Menu Modal -->
<div class="modal fade" id="syncPosModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog" id="modal">
        <div class="modal-content">
            <div class="modal-body">
                <div class="row modal-heading-row">
                    <div class="row heading-row-right">
                        <img src="../../../../../assets/icons/logo.png" width="35px" height="32px"
                            class="d-inline-block align-top" alt="" loading="lazy">
                        <div class="modal-Heading">
                            {{selectedShopName}} - POS Action
                        </div>
                    </div>
                    <img src="../../../../../assets/icons/closeBlack.png" width="18px" height="18px"
                        style="cursor: pointer;" class="d-inline-block align-top" alt="" loading="lazy"
                        (click)="closeModal()">
                </div>
                <hr>
                <p *ngIf="syncMessage != ''  && !isSyncSuccess" class="alert alert-danger">{{syncMessage}}</p>
                <p *ngIf="syncMessage != ''   && isSyncSuccess" class="alert alert-success">{{syncMessage}}</p>
                <div>
                    <div class="modal-text">
                        Last Sync Date : {{lastSyncedDate}}
                    </div>

                    <div class="modal-question">
                        Are you sure you want to sync the items with POS? Please note this action cannot be undone.
                    </div>
                    <div class="terms-checkbox col-md-12">
                        <label class="checkobx-inline">
                            <input type="checkbox" [checked]="isUpdateModifierSelected" (click)="updateModifiers()"
                                style="margin-right: 5px;" />
                            Update delivery platforms modifiers</label>
                    </div>
                    <div class="col-md-12 modal-button-div">
                        <button class="btn modal-btn-sync" type="button" (click)="syncPOS()">
                            <div *ngIf="!isActionClick">Sync Items</div>
                            <div *ngIf="isActionClick" style="position: absolute;">
                                <ngx-spinner bdColor="rgba(255,255,255,0)" size="small" color="#ffffff"
                                    type="ball-clip-rotate" [fullScreen]="false"></ngx-spinner>
                            </div>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<!-- Place Order Modal -->
<div class="modal fade" id="placeOrderModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog" id="modal">
        <div class="modal-content">
            <div class="modal-body">
                <div class="row modal-heading-row">
                    <div class="row heading-row-right">
                        <img src="../../../../../assets/icons/logo.png" width="35px" height="32px"
                            class="d-inline-block align-top" alt="" loading="lazy" data-dismiss="modal">
                        <div class="modal-Heading">
                            Place Test order
                        </div>
                    </div>
                    <img src="../../../../../assets/icons/closeBlack.png" width="18px" height="18px"
                        (click)="onCancel()" style="cursor: pointer;" class="d-inline-block align-top" alt=""
                        loading="lazy">
                </div>
                <hr>
                <form [formGroup]="placeTestOrderForm">
                    <div class="input-full">
                        <div class="form-group">
                            <label for="exampleInputEmail1">Delivery Type</label><span style="color: #DC4A4A;">*</span>
                            <select class="custom-select" style=" font-size: 14px;" id="inlineFormCustomSelect3"
                                formControlName="delivery_type"
                                [ngClass]="{ 'is-invalid': submitted && placeOrder.delivery_type.errors }">
                                <option value='' selected>Choose a Type...</option>
                                <option *ngFor="let type of deliveryOptions; let i = index" value={{type.name}}>
                                    {{type.name}}</option>
                            </select>
                            <div *ngIf="submitted && placeOrder.delivery_type.errors" class="invalid-feedback">
                                <div *ngIf="placeOrder.delivery_type.errors.required">Please select your type</div>
                            </div>
                        </div>
                    </div>
                </form>
                <p *ngIf="testOrderMessage != ''  && !isTestSuccess" class="alert alert-danger">{{testOrderMessage}}</p>
                <p *ngIf="testOrderMessage != ''   && isTestSuccess" class="alert alert-success">{{testOrderMessage}}
                </p>
                <div>

                    <div class="col-md-12 modal-button-div">
                        <button class="btn modal-btn-sync" type="button" (click)="placeTestOrder()">
                            <div *ngIf="!isActionClick">Place Your Test Order</div>
                            <div *ngIf="isActionClick" style="position: absolute;">
                                <ngx-spinner bdColor="rgba(255,255,255,0)" size="small" color="#ffffff"
                                    type="ball-clip-rotate" [fullScreen]="false"></ngx-spinner>
                            </div>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Snooze Orders -->
<div class="modal fade" id="snoozeOrderModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog" id="modal">
        <div class="modal-content">
            <div class="modal-body">
                <div class="row modal-heading-row">
                    <div class="row heading-row-right">
                        <img src="../../../../../assets/icons/logo.png" width="35px" height="32px"
                            class="d-inline-block align-top" alt="" loading="lazy" data-dismiss="modal">
                        <div class="modal-Heading">
                            Snooze Order Accepting
                        </div>
                    </div>
                    <img src="../../../../../assets/icons/closeBlack.png" width="18px" height="18px"
                        (click)="onSnoozeCancel()" style="cursor: pointer;" class="d-inline-block align-top" alt=""
                        loading="lazy">
                </div>
                <hr>
                <div [formGroup]="availableForm">
                    <div class="input-full">
                        <div class="form-group">
                            <label for="exampleInputEmail1" class="lblInput">Snooze Until</label><span
                                style="color: red;">*</span>
                            <select class="custom-select" style=" font-size: 14px;" id="inlineFormCustomSelect3"
                                formControlName="available_from" (ngModelChange)="selectTimezone($event)"
                                [ngClass]="{ 'is-invalid': acceptSubmit && sf.available_from.errors }">
                                <option value='' selected>Choose a time...</option>
                                <option *ngFor="let time of availableTimes" [ngValue]="time">
                                    {{time.timeZone}}
                                </option>
                            </select>
                            <div *ngIf="acceptSubmit && sf.available_from.errors" class="invalid-feedback">
                                <div *ngIf="sf.available_from.errors.required">Please select a time</div>
                            </div>
                        </div>
                    </div>
                </div>
                <p *ngIf="acceptMessage != ''  && !isTestSuccess" class="alert alert-danger">{{acceptMessage}}</p>
                <p *ngIf="acceptMessage != ''   && isTestSuccess" class="alert alert-success">{{acceptMessage}}
                </p>
                <div>

                    <div class="col-md-12 modal-button-div">
                        <button class="btn modal-btn-sync" type="button" (click)="snoozeOrder()">
                            <div *ngIf="!isAcceptLoading">Snooze Order</div>
                            <div *ngIf="isAcceptLoading" style="position: absolute;">
                                <ngx-spinner bdColor="rgba(255,255,255,0)" size="small" color="#ffffff"
                                    type="ball-clip-rotate" [fullScreen]="false"></ngx-spinner>
                            </div>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>